import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormService } from 'app/services/form.service';

@Component({
  selector: 'app-pharmacologic-action',
  templateUrl: './pharmacologic-action.component.html',
  styleUrls: ['./pharmacologic-action.component.scss']
})
export class PharmacologicActionComponent implements OnInit {
  @ViewChild('pharmacologicActionInput') pharmacologicActionInput!: ElementRef;
  pharmacologicAction!: string;

  constructor(private formService: FormService) {}

  ngOnInit(): void {
    this.pharmacologicAction = this.currentForm.get('pharmacologicAction')?.value;
  }

  public clearPharmacologicActionInputField() {
    this.pharmacologicAction = '';
    this.currentForm.patchValue({'pharmacologicAction': ''});
    this.errorCheck();
  }

  public updatePharmacologicAction(event: Event) {
    if(event && event.type === 'blur') {
      var target = document.activeElement;
      if(target && target.nodeValue === "cancel") {
        this.pharmacologicAction = '';
      }
    }
    this.currentForm.patchValue({'pharmacologicAction': this.pharmacologicAction});
    this.errorCheck();
  }

  public cancelUpdate() {
    this.pharmacologicAction = this.currentForm.get('pharmacologicAction')?.value;
    this.errorCheck();
  }

  private errorCheck() {
    const targetControl = this.currentForm.get('pharmacologicAction');
    
    if(!targetControl) {
      return;
    }

    // Force re-validation
    setTimeout(() => {
      targetControl.markAsTouched();
      targetControl.markAsDirty();
      targetControl.updateValueAndValidity();
    });
  }

  get currentForm(): FormGroup {
    return this.formService.getCurrentUsanFormValue();
  }

  public hasFieldValidationError(fieldName: string, errorName?: string): boolean {
    return this.formService.hasFieldValidationError(fieldName, errorName);
  }

}
